import React, { useState, useEffect } from 'react'
import { API_URL } from '../settings'
import axios from 'axios'
import { useAuth } from '../Hooks/useAuth'
import { MONTHS, YEARS } from '../Utils/SelectInputOptions'
import Charts from './Charts';
import DataTables from './DataTables';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const Home = () => {
  const [ data, setData ] = useState(null)
  const [ loading, setLoading ] = useState(false)
  const [ UIdisplay, setUIdisplay ] = useState('charts') // charts or data
  const { user, logout } = useAuth()
  const [ year, setYear ] = useState(new Date().getFullYear())
  const [ month, setMonth ] = useState(new Date().getMonth() + 1)

  const fetchData = async (year, month) => {
    setLoading(true)
    return await axios.post(`${API_URL}/dashboard/get-data`, { from: `${year}-01-01`, to: `${year}-12-31`, year: year.toString(), month: month.toString() }, { headers: { token: user.token, useremail: user.email } })
    .then(res => {
      setData(res.data)
      setLoading(false)
    }).catch(err => {
      console.log(err)
      if (err.response.data.title === "Error in verify token middleware") {
        return logout()
      }
      toast.error(err.response.data.error.body.message, { position: 'top-right', autoClose: 3000 })
      setTimeout(() => {
        setLoading(false) 
      }, 3000)
    })
  }

  // Fetch default data on component mount, based on current year and month
  useEffect(() => {
    fetchData(year, month)
  }, [year, month])

  if (loading) return (
    <div className="flex items-center justify-center h-screen">
      <div className="loader">
        <h5>Loading...</h5>
        <ToastContainer />
      </div>
    </div>
  ) 
  
  return (
    <div className="isolate bg-white px-6 py-10 sm:py-10 lg:px-8 h-screen">
      <ToastContainer />
      <div className='flex justify-end'>
        <p className='text-sm text-pinegreen hover:underline cursor-pointer w-20 hover:font-medium' onClick={logout}>Logout →</p>
      </div>
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold sm:text-5xl bg-gradient-to-r from-pinegreen to-mossgreen bg-clip-text text-transparent sm:py-5">HODL Marketing Dashboard</h2>
      </div>
      <div className="mx-auto max-w-xl sm:mt-5">
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div>
            <label className="block mb-2 text-sm font-medium text-pinegreen">Year*</label>
            <select className="bg-gray-50 border border-pinegreen text-gray-900 text-sm rounded-lg focus:ring-mossgreen focus:border-mossgreen block w-full p-2.5" defaultValue={year} onChange={e => setYear(e.target.value)}>
              <option value="">Choose a Year</option>
              { YEARS.map(year => (<option key={year.id} value={year.name}>{year.name}</option>)) }
            </select>
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium text-pinegreen">Month*</label>
            <select className="bg-gray-50 border border-pinegreen text-gray-900 text-sm rounded-lg focus:ring-mossgreen focus:border-mossgreen block w-full p-2.5" defaultValue={month} onChange={e =>setMonth(e.target.value)}>
              <option value="">Choose a Month</option>
              { MONTHS.map(month => (<option key={month.id} value={month.id}>{month.name}</option>)) }
            </select>
          </div>
        </div>
      </div>
     
      { data && 
        <>
          <div className='flex justify-center'>
            { data.allowedUser && 
                <ul className="flex flex-wrap text-sm font-medium text-center text-label">
                  <li className="me-2">
                    <button onClick={() =>setUIdisplay("charts")} className="hover:ring-1 ring-pinegreen text-pinegreen font-semibold py-2 px-8 border border-pinegreen hover:border-transparent rounded-lg mt-10">Charts</button>
                  </li>
                  <li className="me-2">
                    <button onClick={() => setUIdisplay("data")} className="hover:ring-1 ring-pinegreen text-pinegreen font-semibold py-2 px-8 border border-pinegreen hover:border-transparent rounded-lg mt-10">Data Tables</button>
                  </li>
                </ul>
            }
          </div>
          { UIdisplay === 'charts' && <Charts data={data} /> }
          { ( UIdisplay === 'data' && data.allowedUser ) && <DataTables data={data} fetchData={fetchData} /> }
        </> 
      }
    </div>
  )
}
export default Home;